export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// The library's own header prints the raw month number, so "12 2026" rather
// than a date. Abbreviating against the same list the trigger already uses
// keeps the two readings of the value consistent.
export const formatMonthYear = (date: Date) =>
  `${monthNames[date.getMonth()].slice(0, 3)} ${date.getFullYear()}`;

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${
    monthNames[date.getMonth()]
  } ${date.getDate()} / ${date.getFullYear()}`;
};
